export default __webpack_public_path__ + "static/media/braces-removivel.3d8adc78.png";